export type BubbleBox = { left: number; top: number; width: number; height: number }
export type BubbleBounds = { left: number; top: number; right: number; bottom: number }
export type ComputeBubbleBoundsArgs = { box: BubbleBox; viewportWidth: number; viewportHeight: number }

export const computeBubbleBounds = ({ box, viewportWidth, viewportHeight }: ComputeBubbleBoundsArgs): BubbleBounds => ({
  left: -box.left,
  top: -box.top,
  right: viewportWidth - box.left - box.width,
  bottom: viewportHeight - box.top - box.height,
})
